module.exports = __webpack_public_path__ + "fonts/roboto-all-100.54ec0d61.woff2";